import styled from 'styled-components';

export const StepperContain = styled.div`
  height: 3.5em;
  border-radius: 1.5em;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  background-color: rgb(73, 94, 106);
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
`;

export const StepContain = styled.div`
  flex: 1;
  color: #ffffffab;
  height: 100%;
  display: flex;
  font-size: 1em;
  font-weight: 500;
  position: relative;
  font-family: roboto;
  align-items: center;
  padding-left: 2em;
  position: relative;
  justify-content: flex-start;

  ${(props) =>
    props.current &&
    `
      color: ${(props) => props.theme.brandColor}
    `}

  ${(props) =>
    props.complete &&
    `
      color: ${(props) => props.theme.warningColor}
    `}

  ${(props) =>
    props.hidden &&
    `
      display: none;
    `}
`;

export const StepCircle = styled.div`
  width: 1.5em;
  height: 1.5em;
  display: flex;
  margin-right: 0em
  align-items: center;
  border-radius: 9999px;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0px 0px 0px 1px #c7d7e1;

    ${(props) =>
      props.current &&
      `
      box-shadow: 0px 0px 0px 2px ${props.theme.brandColor} !important;
  `}

   ${(props) =>
     props.complete &&
     `
      background-color: transparent;
      box-shadow: 0px 0px 0px 2px #fff !important;
    `}
`;

export const StepLine = styled.div`
  height: 1px;
  position: absolute;
  width: calc(100% - 4em);
  left: 2em;
  background-color: #e6e6e6;
`;

export const StepCheck = styled.div`
  background-color: ${(props) => props.theme.brandColor};
  min-width: 1.25em;
  min-height: 1.25em;
  border-radius: 9999px;
`;

export const IconContain = styled.div`
  position: relative;
  left: 0.2em;
`;

export const StepLabel = styled.div`
  padding: 0.25em 0.5em;
  margin-left: 2px;
  white-space: nowrap;
`;

export const StepperBarContain = styled.div`
  height: 0.5em;
  width: 100%;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: inset 0px -1px 0px 0px #dfdfdf;
  margin-bottom: 0.5em;
`;

export const StepperBarFill = styled.div`
  width: ${(props) => props.percent}%;
  height: 100%;
  transition: all 0.3s ease-in-out;
  background-color: rgb(67, 170, 172);
`;
